import n from './node_modules/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".mds-highlighted-match {\n  font-weight: 700;\n  color: unset;\n  white-space: pre-wrap;\n  background: unset;\n}\n\n.mds-highlighted-match-item {\n  white-space: pre-wrap;\n}\n";
n(css,{"container":"body","singleTag":true,"prepend":true,"attributes":{"id":"@magnetic/highlighted-match"}});

export { css, css as default };
//# sourceMappingURL=styles.css.js.map
